"use client";
import Hyperlink from "../ui/hyperlink";

interface ExplorCardData {
    title: string;
    description: string;
    btnText: string;
    link: string;
}

interface Props {
    data: ExplorCardData;
}

const ExplorAreaCard = ({ data }: Props) => {
    return (
        <>
            <div

                className="col-md-6 col-xl-4"
            >
                <div className="desilo-service-box6 bg-color-2 move-anim">
                    <div className="mt-0 d-flex flex-column justify-content-between h-100">
                        <div>
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>

                        </div>
                        <Hyperlink
                            className="mt-3 mt-lg-4 h-fit"
                            href={`${data.link}`}
                        >
                            {data.btnText}
                        </Hyperlink>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExplorAreaCard;
